import { Stack, styled } from '@mui/material';

interface ProfilePictureProps {
  familycontainerwidth: HTMLElement;
}

export const ProfilePictureStyled = styled(Stack)<ProfilePictureProps>(
  ({ theme, familycontainerwidth }) => ({
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      margin: familycontainerwidth
        ? `${theme.spacing(6)} auto ${theme.spacing(4)}`
        : `${theme.spacing(20)} auto ${theme.spacing(4)}`,
    },
  })
);
